import AnalysisPrediction from './AnalysisPrediction';
export default AnalysisPrediction;
